import { InsulationElement } from "./InsulationElement";
import { InsulationElementType } from "../../constants/combo/InsulationElementType";

export class WallElement extends InsulationElement {
  getElementType = () => InsulationElementType.WALL;
}
